// extracted by mini-css-extract-plugin
export default {"controlsWrapper":"CalendarDateHeader__controlsWrapper___HbNr8","titleFormat":"CalendarDateHeader__titleFormat___Pb8bw","arrowButton":"CalendarDateHeader__arrowButton___cGbv_"};